import { useTranslation } from "react-i18next";
import { COMMON_TRANSLATE_KEYS } from "../constants/translate-keys";

const AboutPage = () => {
  const { t } = useTranslation();

  return (
    <div className="px-8 mb-10">
      <article className="my-10 text-mainWhite text-xl flex flex-col gap-10">
        <p className="indent-10"><b className="font-bold">Bolarena</b> {t(COMMON_TRANSLATE_KEYS.ABOUT_FIRST_PARAGRAPH)}</p>
        <p className="indent-10">{t(COMMON_TRANSLATE_KEYS.ABOUT_SECOND_PARAGRAPH)}</p>
        <p className="indent-10">{t(COMMON_TRANSLATE_KEYS.ABOUT_THIRD_PARAGRAPH)}</p>
        <p className="indent-10">{t(COMMON_TRANSLATE_KEYS.ABOUT_FOURTH_PARAGRAPH)}</p>
      </article>
    </div>
  );
};

export default AboutPage;
